import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { Icon } from "@iconify/react";
gsap.registerPlugin(ScrollTrigger);

const AboutSection = () => {
    const sectionRef = useRef(null);
    const imageRef = useRef(null);
    const textRef = useRef(null);
    const paragraphsRef = useRef([]);

    useEffect(() => {
        const ctx = gsap.context(() => {
            // Fade in and slide up section
            gsap.from(sectionRef.current, {
                opacity: 0,
                y: 100,
                duration: 1.2,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 80%",
                    toggleActions: "play none none reverse",
                },
            });

            // Image smooth entrance
            gsap.from(imageRef.current, {
                x: -100,
                opacity: 0,
                duration: 1.2,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: imageRef.current,
                    start: "top 85%",
                    toggleActions: "play none none reverse",
                },
            });

            // Heading animation
            gsap.from(textRef.current, {
                x: 100,
                opacity: 0,
                duration: 1.2,
                delay: 0.2,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: textRef.current,
                    start: "top 85%",
                    toggleActions: "play none none reverse",
                },
            });

            // Paragraphs stagger animation
            gsap.from(paragraphsRef.current, {
                opacity: 0,
                y: 40,
                stagger: 0.2,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: paragraphsRef.current[0],
                    start: "top 90%",
                    toggleActions: "play none none reverse",
                },
            });
        }, sectionRef);

        return () => ctx.revert();
    }, []);

    return (
        <>
            <section id="about"
                ref={sectionRef}
                className="about relative min-h-screen bg-black text-white overflow-hidden flex flex-col justify-center px-6 md:px-20 lg:px-10 xl:px-20 py-24 xl:mt-76 lg:mt-72"
            >

                <div className="relative z-10 mx-auto grid xl:grid-cols-3 lg:grid-cols-3 items-center xl:gap-0 lg:gap-8">
                    <div className="text-center ">
                        <img ref={imageRef} className="xl:h-[400px] w-[400px] opacity-90" src="https://api.visko.group/public/assets/img/uploads/ticket-docs/Union.webp" alt="" />
                    </div>
                    <div className="col-span-2">
                        <button className="bg-white/10 border border-white/20 px-4 sm:px-6 py-2 mb-6 rounded-full text-xs sm:text-sm hover:bg-white/20 transition-all flex items-center">
                            <Icon
                                icon="material-symbols:lightbulb-2-rounded"
                                className="mr-2 text-[#F26A33] drop-shadow-[0_0_8px_#F26A33]"
                                width="22"
                                height="22"
                            />
                            ABOUT OUR COMPANY
                        </button>

                        <h1 ref={textRef} className="text-4xl lg:text-4xl xl:text-7xl font-light leading-snug text-gray-400">
                            {/* Simplify your hiring through smart,{" "} */}
                            Simplify hiring with intelligent,{" "}
                            <span className="text-white font-normal">
                                automated solutions that connect Dubai
                            </span>{" "}
                            employers and job seekers delivering faster, smarter and{" "}
                            <span className="text-white font-normal">more reliable recruitment results.</span>
                        </h1>
                    </div>
                </div>

                {/* PARAGRAPHS */}
                <div className="relative z-10 max-w-screen-2xl grid md:grid-cols-2 gap-10 md:mt-16 mt-10 mx-auto">
                    <p
                        ref={(el) => (paragraphsRef.current[0] = el)}
                        className="text-gray-400 text-base sm:text-base xl:text-xl leading-relaxed bg-neutral-900 md:p-12 p-4 border border-neutral-800 hover:text-white "
                    >
                        <span className="text-white font-normal">Founded in 2022, Visko HR LLC </span>
                        is a modern AI-driven recruitment company focused on transforming hiring across Dubai and the UAE. We believe recruitment should be efficient, transparent, and data-driven built on trust, innovation, and performance.
                    </p>
                    <p
                        ref={(el) => (paragraphsRef.current[1] = el)}
                        className="text-gray-400 text-base sm:text-base xl:text-xl leading-relaxed  bg-neutral-900 md:p-12 p-4 border border-neutral-800 hover:text-white "
                    >
                        <span className="text-white font-normal">At the core of our ecosystem is Remark, </span>
                        our AI-powered job portal designed for Dubai’s fast-paced hiring needs. Using intelligent matching and real-time insights, Remark helps employers hire better talent while enabling job seekers to find roles that truly fit their potential.                    </p>
                </div>
            </section>
        </>
    );
};

export default AboutSection;
